var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"profile-reply"},[_c('font-awesome-icon',{staticClass:"text-secondary cancel-reply pointer",attrs:{"icon":"times"},on:{"click":_vm.hide}}),_c('div',{class:['wrap_msg_cotainer_send', { 'w-100': _vm.msg.messageType == 4 }]},[_c('div',{class:[
        'reply_container',
        _vm.msg.messageType == 4 || _vm.msg.messageType == 2
          ? 'msg_cotainer_img'
          : 'msg_cotainer'
      ]},[_c('ChatBoxReplyProfile',{attrs:{"msg":_vm.msg}}),(_vm.msg.messageType == 4)?_c('div',{staticClass:"wrap_img_upload"},[_c('div',{staticClass:"img_upload"},[_c('div',{staticClass:"img_upload-display",style:({
              backgroundImage: 'url(' + _vm.msg.filePath + ')'
            })})])]):_c('span',{staticClass:"text-nextline",domProps:{"innerHTML":_vm._s(_vm.msg.message)}})],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }